import { columns } from "../../../../dtos/columns";
import AccionesPoliza from "../components/accionesPoliza";
import { PolizaEditar, PolizaSeguro, UpdatePoliza } from "../models/polizaSeguro";

interface IProps {
    controlTabla: any;
    setPolizaEditar?: React.Dispatch<React.SetStateAction<UpdatePoliza | undefined>>;
    setModalDetalle?: React.Dispatch<React.SetStateAction<boolean>>;
    handleCreateEditButtonClick: () => void;
    setIsEditar?: (value: boolean) => void;

}

export function useColumns({ controlTabla, setPolizaEditar, setModalDetalle, handleCreateEditButtonClick, setIsEditar }: IProps) {
    const COLUMNS: columns<PolizaSeguro>[] = [
        {
            name: 'Acciones',
            selector: (row) => '',
            cell: (row) =>
                <AccionesPoliza
                    poliza={row}
                    control={controlTabla}
                    setPolizaEditar={setPolizaEditar}
                    setModalDetalle={setModalDetalle}
                    onCreateEditClick={handleCreateEditButtonClick}
                    setIsEditar={setIsEditar}
                />,
            allowOverflow: true,
            button: true,
            export: false,
            alling: 'center'
        },
        {
            name: 'Código',
            selector: (row) => row.codigo,
            sortable: true,
            sortField: 'codigo',
            wrap: true,
            export: true
        },
        {
            name: 'Código hijo',
            selector: (row) => row.codigohijo,
            sortable: true,
            sortField: 'codigohijo',
            wrap: true,
            export: true
        },
        {
            name: 'Nombre compañia seguro',
            selector: (row) => row.nombrecompania,
            sortable: true,
            sortField: 'nombrecompania',
            wrap: true,
            export: true
        },
        {
            name: 'Tasa',
            selector: (row) => row.tasa,
            sortable: true,
            sortField: 'tasa',
            wrap: true,
            export: true
        },
        {
            name: 'Día remesa',
            selector: (row) => row.monedapagoCodigo,
            cell: (row) => {
                if (row.monedapagoCodigo === 'UF') return 'UF SAC';
                if (row.monedapagoCodigo === 'F') return 'UF';
                return row.monedapagoCodigo;
            },
            sortable: true,
            sortField: 'monedapagoCodigo',
            wrap: true,
            export: true
        },

        {
            name: 'Moneda remesa',
            selector: (row) => row.monedapagoCodigo,
            cell: (row) => {
                if (row.monedapagoCodigo === 'UF') return 'UF SAC';
                if (row.monedapagoCodigo === 'F') return 'UF';
                return row.monedapagoCodigo;
            },
            sortable: true,
            sortField: 'monedapagoCodigo',
            wrap: true,
            export: true
        },
    ];

    return { COLUMNS };
}